module.exports = __webpack_public_path__ + "media/images/emoji-c09769f1dacb11178ba48bb8ae44beb601566821e6a31f3ba4f00a6e83927b88.png";